import { Edit } from "@mui/icons-material";
import { Box, Card, CardContent } from "@mui/material";
import {
  EmailField,
  SimpleShowLayout,
  TextField,
  useGetIdentity,
  TopToolbar,
  Button,
} from "react-admin";
import { Link } from "react-router-dom";

export const SettingsShow = () => {
  const { data: identity, isLoading } = useGetIdentity();

  if (isLoading || !identity) return null;

  return (
    <>
      <Box sx={{ flex: "0 1 auto" }}>
        <TopToolbar>
          <Button
            label="Edit"
            startIcon={<Edit />}
            component={Link}
            to="/settings/edit"
          />
        </TopToolbar>
      </Box>
      <Card>
        <CardContent>
          <SimpleShowLayout record={identity}>
            <TextField source="username" emptyText="-" />
            <EmailField source="email" emptyText="-" />
          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>
  );
};
